import { MessageStyle } from '@store/modules/ui/inbox/types';

import { MessageStyleDto } from './dtos/InboxMessageDto';

export function transformMessageStyle(dto: MessageStyleDto): MessageStyle {
    return {
        background: dto.bg,
        titleBackground: dto.title_bg,
        type: dto.type,
    };
}
